import { NetworkType } from 'tsjs-xpx-chain-sdk';
import * as config from '../../../config.json'

export const CATAPULT_CONSTANTS = {
	networkType: NetworkType[config.catapult.networkType]
};
